module.exports = __webpack_public_path__ + "media/packs/images/flags/UA-3c6938f02494a8ac5424ca4f5de3bd3b.svg";